<template>
  <div v-if="localChildren && localChildren.length > 0">
    <v-row
      v-for="(child, index) in localChildren"
      :key="child.id"
    >
      <v-col>
        <SubsidyChild
          @cancel="cancel(child)"
          @change="updateChild($event, index)"
          :autofocus="autofocus"
          :has-existing-subsidy="hasExistingSubsidy(child)"
          :index="index"
          :initial-child="child"
          :prevent-update="preventUpdate"
          included-check
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="fs-15">
        {{ $bct("Don't see the child you're looking for?") }}
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          @click="addChild"
          :loading="processing"
          class="focus-very-visible"
          color="primary"
          prepend-icon="add"
        >
          {{ $bct('Add another child') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import _ from 'lodash';
import { useStore } from 'vuex';

import SubsidyChild from '@/parent/components/subsidy/SubsidyChild.vue';

const props = defineProps({
  autofocus: Boolean,
  children: {
    default: null,
    type: Array,
  },
  childrenWithExistingSubsidies: {
    default: null,
    type: Array,
  },
  preventUpdate: Boolean,
});

const emit = defineEmits(['change']);

const store = useStore();
const $bct = inject('translator');

const localChildren = ref(props.children);
const processing = ref(false);

const addChild = () => {
  localChildren.value.push({
    ...defaultChild(),
    included: true,
    editing: true,
  });
};

const cancel = (child) => {
  if (isPersisted(child)) {
    child.editing = false;
  } else {
    localChildren.value.pop();
  }
};

const defaultChild = () => {
  return {
    schema_id: Object.values(store.state.schemas).filter(
      (schema) => schema.data_type === 'Child',
    )[0].id,
  };
};

const isPersisted = (child) => !_.isNil(child.id);

const updateChild = (child, localChildrenIndex) => {
  localChildren.value[localChildrenIndex] = child;

  emit('change', localChildren.value);
};

const hasExistingSubsidy = (child) => {
  return props.childrenWithExistingSubsidies?.some((childId) => childId === child.id);
};

watch(
  () => props.children,
  (newVal) => {
    localChildren.value = newVal;
  },
);

onMounted(() => {
  if (localChildren.value.length === 0) {
    addChild();
  }
});
</script>
